var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 35.5C15 24.4543 23.9543 15.5 35 15.5H45C56.0457 15.5 65 24.4543 65 35.5V45.5C65 56.5457 56.0457 65.5 45 65.5H35C23.9543 65.5 15 56.5457 15 45.5V35.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 49.0833C50.9167 49.0833 49.5 49.7083 48.4167 50.6875L33.5625 42.0417C33.6667 41.5625 33.75 41.0833 33.75 40.5833C33.75 40.0833 33.6667 39.6042 33.5625 39.125L48.25 30.5625C49.375 31.6042 50.8542 32.25 52.5 32.25C55.9583 32.25 58.75 29.4583 58.75 26C58.75 22.5417 55.9583 19.75 52.5 19.75C49.0417 19.75 46.25 22.5417 46.25 26C46.25 26.5 46.3333 26.9792 46.4375 27.4583L31.75 36.0208C30.625 34.9792 29.1458 34.3333 27.5 34.3333C24.0417 34.3333 21.25 37.125 21.25 40.5833C21.25 44.0417 24.0417 46.8333 27.5 46.8333C29.1458 46.8333 30.625 46.1875 31.75 45.1458L46.5833 53.8125C46.4792 54.25 46.4167 54.7083 46.4167 55.1667C46.4167 58.5208 49.1458 61.25 52.5 61.25C55.8542 61.25 58.5833 58.5208 58.5833 55.1667C58.5833 51.8125 55.8542 49.0833 52.5 49.0833Z",
    fill: "#D1337F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "#D1337F",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f631b61d42d5c85c3de2edd5d3f296f8.svg";
export { ForwardRef as ReactComponent };